(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PatchReportPhotoDialogController', PatchReportPhotoDialogController);

    PatchReportPhotoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'PatchReportPhoto', 'PatchReport'];

    function PatchReportPhotoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, PatchReportPhoto, PatchReport) {
        var vm = this;
        vm.patchReportPhoto = entity;
        vm.patchreports = PatchReport.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:patchReportPhotoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.patchReportPhoto.id !== null) {
                PatchReportPhoto.update(vm.patchReportPhoto, onSaveSuccess, onSaveError);
            } else {
                PatchReportPhoto.save(vm.patchReportPhoto, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.setPatchPhoto = function ($file, patchReportPhoto) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        patchReportPhoto.patchPhoto = base64Data;
                        patchReportPhoto.patchPhotoContentType = $file.type;
                    });
                });
            }
        };

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();
